import React, { useCallback, useContext, useEffect, useState } from 'react'
import AdminLocalContractsRenovations from './AdminLocalContractsRenovations'
import ModalTableHistorial from './ModalTableHistorial'
import ModalTableCtaCte from './CtaCte/TableCtaCte'
import { Button } from '../../Common/utils/button/button.component'
import { Box, FormControlLabel, IconButton, Switch, Typography, useMediaQuery, useTheme } from '@mui/material'
import { styled } from '@mui/material'
import { useLocalContracts } from '../../../hooks/admin.local.contracts.hook'
import ModalTableLinks from './Links/ModalTableLinks'
import ModalTablePagos from './Pagos/ModalTablePagos'
import CrearContrato from './DialogCrearContrato'
import DialogCambiarProductos from './DialogCambiarProducto'
import { InfoOutlined } from '@mui/icons-material'
import SnackBarUtils from '../../../utils/SnackBarUtils'
import { ContractDTO, MedioPago } from '../../../dto/ContractDTO'
import { RolType } from '../../Navbar/Sidebar/SidebarItems'
import { DataContratosContext } from '../context/data.contratos.context'
import { useSortableData } from '../../../utils/UseSorteableDataHook'
import { useProductosContrato } from '../../ContractsList/hooks/productos.contrato.hook'
import { INITIAL_ROWS_PER_PAGE } from '../../../pages/Products/components/TableDataPagination'
import { getMediosPago } from '../../../pages/Contracts/Vencimientos/contracts.services'
import { getCtaCte } from '../services/cta.cte.services'
import PerfilFact from './Cuit/ContractPerfil'
import CardsCtaCte from './CtaCte/CardsCtaCte'
import ModalCtaCte from './CtaCte'

const ContentTable = styled('div')(({ isMobile }: { isMobile: boolean }) => ({
  width: isMobile ? '100%' : '97%',
  overflowX: isMobile ? 'auto' : 'visible'
}))

const ButtonChangeProduct = styled(Button)(({ theme }) => ({
  fontSize: '0.70rem',
  margin: '1px',
  width: '100%',
  padding: '6px 2px',
  lineHeight: '1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down(425)]: {
    width: '100%'
  }
}))

const ButtonTable = styled(Button)(({ theme }) => ({
  fontSize: '0.75rem',
  margin: '1px',
  width: '85%',
  [theme.breakpoints.down(425)]: {
    width: '100%'
  }
}))

const AdminLocalContracts: React.FC<any> = (props: any) => {
  const [showRenovations, setShowRenovations] = useState<boolean>(false)
  const [showHistory, setShowHistory] = useState<boolean>(false)
  const [contractIdChecked, setContractIdChecked] = useState<number>()
  const [showCtaCte, setShowCtaCte] = useState<boolean>(false)
  const [renewContract, setRenewContract] = useState<ContractDTO>()
  //const [idLocal, setIdLocal] = useState<string>();
  const [showPagos, setShowPagos] = useState<boolean>(false)
  const [showLinks, setShowLinks] = useState<boolean>(false)
  const [resultCtaCte, setResultCtaCte] = useState<any[]>([])
  const [openCambiarProductos, setOpenCambiarProductos] = useState<boolean>(false)
  const [openCrearContrato, setOpenCrearContrato] = useState<boolean>(false)
  const [productoACambiar, setProductoACambiar] = useState<ContractDTO>()
  const [mediosDePago, setMediosDePago] = useState<MedioPago[]>([])
  const isOperador = props?.props?.logged?.userLogged?.roles.includes(RolType.MOD)
  const {
    fetchLinks,
    fetchPagos,
    linksContrato,
    pagosContrato,
    loading: loadingData,
    setLinksContrato,
    setPagosContrato,
    setPageLinks,
    setPageSizeLinks,
    setPagePagos,
    setPageSizePagos
  } = useContext(DataContratosContext)
  const { perfil, contracts, forzarRenovables, setForzarRenovables, fetchLocalContracts, consultarPerfil } =
    useLocalContracts(props.premise?.idLocal)
  const { items, requestSort, sortConfig } = useSortableData(contracts)
  const { productos, fetchProductosContrato } = useProductosContrato()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const getClassNamesFor = (name: string) => {
    if (!sortConfig) {
      return
    }
    return sortConfig['key'] === name ? sortConfig['direction'] : undefined
  }

  const closeModalRenovation = () => {
    setShowRenovations(false)
  }

  const closeModalHistory = () => {
    setShowHistory(false)
  }

  const closeModalCtaCte = () => {
    setShowCtaCte(false)
  }

  const closeModalLinks = () => {
    setShowLinks(false)
    setLinksContrato(null)
    setPageLinks(0)
    setPageSizeLinks(INITIAL_ROWS_PER_PAGE)
  }

  const closeModalPagos = () => {
    setShowPagos(false)
    setPagosContrato(null)
    setPagePagos(0)
    setPageSizePagos(INITIAL_ROWS_PER_PAGE)
  }

  const handleOpenLinks = (idContrato: number) => {
    fetchLinks(idContrato)
    setShowLinks(true)
  }

  const handleOpenPagos = (idContrato: number) => {
    fetchPagos(idContrato)
    setShowPagos(true)
  }

  const getMediosDePago = async () => {
    getMediosPago()
      .then((result) => {
        setMediosDePago(result.data.data.results)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const updateCtaCte = useCallback(
    async (idLocal: any) => {
      await getCtaCte(idLocal)
        .then((result) => {
          setResultCtaCte(
            result.data.sort((a: any, b: any) => {
              const dateA = new Date(a.fecha)
              const dateB = new Date(b.fecha)
              return dateB.getTime() - dateA.getTime()
            })
          )
        })
        .catch((error) => {
          console.log(error)
        })
    },
    [props.premise?.idLocal]
  )

  useEffect(() => {
    if (props.premise) {
      fetchProductosContrato()
      getMediosDePago()
      updateCtaCte(props.premise?.idLocal)
    }
  }, [props.premise, forzarRenovables])

  const updateDataContratos = (id: any) => {
    props.updateLocal(id)
    fetchLocalContracts(id, forzarRenovables)
    updateCtaCte(id)
  }

  return (
    <>
      {!isOperador && (
        <AdminLocalContractsRenovations
          contract={renewContract}
          show={showRenovations}
          handleClose={closeModalRenovation}
          getLocal={fetchLocalContracts}
          idLocal={props.premise?.idLocal}
          forzarRenovables={forzarRenovables}
          updateLocal={props.updateLocal}
        />
      )}
      <ModalTableHistorial
        show={showHistory}
        handleClose={closeModalHistory}
        headers={['Fecha', 'Estado', 'Fecha inicio', 'Fecha fin', 'Obs']}
        attributesToShow={['fecha', 'estadoNombre', 'fechaInicio', 'fechaFin', 'observaciones']}
        getUrl={`/contratos/${contractIdChecked}/historial`}
        title={'Historial'}
      />
      <ModalCtaCte
        show={showCtaCte}
        handleClose={closeModalCtaCte}
        idLocal={props.premise?.idLocal}
        result={resultCtaCte}
        updateCtaCte={updateCtaCte}
        mediosDePago={mediosDePago}
      />
      {linksContrato && (
        <ModalTableLinks
          show={showLinks}
          loading={loadingData}
          data={linksContrato}
          handleClose={closeModalLinks}
          headers={['ID Link', 'Fecha Alta', 'Fecha Vencimiento', 'Medio de pago', 'Fuente', 'Tiene Pagos', 'Link']}
          title={'Links'}
          codLocal={props.premise?.codLocal}
        />
      )}
      {pagosContrato && (
        <ModalTablePagos
          show={showPagos}
          loading={loadingData}
          data={pagosContrato}
          handleClose={closeModalPagos}
          headers={['Estado', 'Monto', 'Nro operación', 'Fecha', 'Mensaje Resultado', 'Historial de cambios']}
          title={'Pagos'}
        />
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: isMobile ? 'flex-start' : 'center',
          justifyContent: 'space-between',
          width: '98%',
          marginTop: isMobile ? '0rem' : '2rem',
          marginLeft: '1.6rem',
          ...(isMobile && { marginLeft: '20px', gap: '1rem' })
        }}
      >
        {!isMobile && items?.length > 0 && (
          <PerfilFact perfil={perfil} codLocal={props?.premise?.codLocal} consultarPerfil={consultarPerfil} />
        )}
        {!isOperador && (
          <Box
            sx={{
              display: 'flex',
              gap: '12px',
              alignItems: isMobile ? 'flex-start' : 'flex-end',
              justifyContent: isMobile ? 'flex-start' : 'flex-end'
            }}
          >
            <Box sx={{ alignSelf: 'flex-start' }}>
              <button
                className="btn btn-primary"
                style={{ marginRight: '5px' }}
                onClick={() => setOpenCrearContrato(true)}
              >
                Crear
              </button>
              <button
                className="btn btn-secondary premise-info-child"
                style={{ fontSize: '1rem' }}
                onClick={() => setShowCtaCte(true)}
              >
                Cta Cte
              </button>
            </Box>
            <Box>
              <FormControlLabel
                label="Forzar renovables"
                control={<Switch onChange={(e) => setForzarRenovables(e.target.checked)} checked={forzarRenovables} />}
              />
            </Box>
          </Box>
        )}
      </Box>

      <ContentTable isMobile={isMobile}>
        <table className="table table-striped table-bordered premise-table">
          <thead className="table-active">
            <tr
              style={{
                ...(isMobile && { fontSize: '14px' })
              }}
            >
              <th>
                <button
                  type="button"
                  onClick={() => requestSort('idContrato')}
                  className={getClassNamesFor('idContrato')}
                >
                  ID
                </button>
              </th>
              <th>
                <button
                  type="button"
                  onClick={() => requestSort('productoNombre')}
                  className={getClassNamesFor('productoNombre')}
                >
                  Producto
                </button>
              </th>
              <th>
                <button
                  type="button"
                  onClick={() => requestSort('fechaFinFormateada')}
                  className={getClassNamesFor('fechaFinFormateada')}
                >
                  Vencimiento
                </button>
              </th>
              <th>
                <button
                  type="button"
                  onClick={() => requestSort('estadoNombre')}
                  className={getClassNamesFor('estadoNombre')}
                >
                  Estado
                </button>
              </th>
              {!isOperador && (
                <th
                  style={{
                    ...(isMobile && { fontSize: '14px' })
                  }}
                >
                  <button
                    type="button"
                    onClick={() => requestSort('precioLista')}
                    className={getClassNamesFor('precioLista')}
                  >
                    Precio
                  </button>
                </th>
              )}
              {!isOperador && (
                <th
                  style={{
                    ...(isMobile && { fontSize: '14px' })
                  }}
                >
                  <button type="button" onClick={() => requestSort('saldo')} className={getClassNamesFor('saldo')}>
                    Saldo Pendiente
                  </button>
                </th>
              )}
              <th>
                <button
                  type="button"
                  onClick={() => requestSort('observaciones')}
                  className={getClassNamesFor('observaciones')}
                >
                  Observaciones
                </button>
              </th>
              {!isOperador && (
                <>
                  <th style={{ width: '13vmin' }}></th>
                  <th style={{ width: '13vmin' }}></th>
                  {items.some((i: ContractDTO) => {
                    return i.accionesAdminList && i.accionesAdminList.length > 0
                  }) && <th style={{ width: '13vmin' }}></th>}
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {items?.map((item: ContractDTO, index) => {
              return (
                <React.Fragment key={index}>
                  <tr
                    key={index}
                    style={{
                      ...(isMobile && { fontSize: '14px' })
                    }}
                  >
                    <th>{item.idContrato}</th>
                    <th style={{ backgroundColor: `#${item.colorProducto}` }}>
                      {item.cantidad > 1 ? item.productoNombre + 'x' + item.cantidad : item.productoNombre}
                    </th>
                    <th>{item.fechaFinFormateada}</th>
                    <th style={{ backgroundColor: `#${item.colorEstado}` }}>{item.estadoNombre}</th>
                    {!isOperador && (
                      <th>
                        {item.precioLista?.toLocaleString('es-ES')}
                        {item.precioActualizado && (
                          <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <Typography color={'primary'}>actualizado</Typography>
                            <IconButton
                              sx={{ marginTop: '-4px', marginLeft: '-2px' }}
                              color="primary"
                              onClick={() =>
                                SnackBarUtils.info('El precio cambió respecto de la última vez que pagó el contrato')
                              }
                            >
                              <InfoOutlined fontSize="small" />
                            </IconButton>
                          </div>
                        )}
                      </th>
                    )}
                    {!isOperador && <th>{item.saldo}</th>}
                    <th>{item.observaciones}</th>
                    {!isOperador && (
                      <>
                        <th style={{ padding: '4px' }}>
                          <div
                            style={{
                              marginTop: '4px',
                              display: 'flex',
                              gap: '5px'
                            }}
                          >
                            <ButtonTable
                              // disabled={!item.renovable}
                              size="small"
                              className="btn btn-secondary premise-info-child"
                              onClick={() => {
                                setContractIdChecked(item.idContrato)
                                setShowHistory(true)
                              }}
                            >
                              Historial
                            </ButtonTable>
                            <ButtonTable
                              size="small"
                              className="btn btn-secondary premise-info-child"
                              onClick={() => handleOpenLinks(item.idContrato)}
                            >
                              Links
                            </ButtonTable>
                            <ButtonTable
                              size="small"
                              className="btn btn-secondary premise-info-child"
                              onClick={() => handleOpenPagos(item.idContrato)}
                            >
                              Pagos
                            </ButtonTable>
                          </div>
                        </th>
                        <th style={{ padding: '4px' }}>
                          <ButtonChangeProduct
                            size="small"
                            className="btn btn-secondary premise-info-child"
                            onClick={() => {
                              setProductoACambiar(item)
                              setOpenCambiarProductos(true)
                            }}
                            sx={{ marginTop: '4px' }}
                          >
                            Cambiar Producto
                          </ButtonChangeProduct>
                        </th>
                        {item.accionesAdminList !== null &&
                          item.accionesAdminList !== undefined &&
                          item.accionesAdminList &&
                          item.accionesAdminList.length > 0 &&
                          !isOperador && (
                            <th style={{ padding: '4px' }}>
                              <ButtonTable
                                // disabled={
                                //   item.accionesAdminList === null ||
                                //   item.accionesAdminList === undefined ||
                                //   (item.accionesAdminList &&
                                //     item.accionesAdminList.length === 0)
                                // }
                                size="small"
                                className="btn btn-primary premise-info-child"
                                onClick={() => {
                                  setShowRenovations(true)
                                  setRenewContract(item)
                                }}
                              >
                                Acciones
                              </ButtonTable>
                            </th>
                          )}
                      </>
                    )}
                  </tr>
                </React.Fragment>
              )
            })}
          </tbody>
        </table>
      </ContentTable>
      {isMobile && items?.length > 0 && (
        <PerfilFact perfil={perfil} codLocal={props?.premise?.codLocal} consultarPerfil={consultarPerfil} />
      )}
      <CrearContrato
        open={openCrearContrato}
        idLocal={props.premise?.idLocal}
        productos={productos}
        openDialog={setOpenCrearContrato}
        updateContractsData={updateDataContratos}
        mediosDePago={mediosDePago}
      />
      {productoACambiar && (
        <DialogCambiarProductos
          open={openCambiarProductos}
          productos={productos}
          idProductoActual={productoACambiar.idContratoProducto}
          openDialog={setOpenCambiarProductos}
          idContrato={productoACambiar.idContrato}
          idLocal={props.premise?.idLocal}
          updateContractsData={updateDataContratos}
          mediosDePago={mediosDePago}
        />
      )}
    </>
  )
}

export default AdminLocalContracts
